import * as React from 'react';
import { Box } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { SystemNoteItem } from './SystemNoteItem';
import { Loading } from '../Loading';
import {
  getUserRoleByRoleModule,
  type UserRole,
  type ROLES_MODULE,
  roleModulesMap,
} from '../RoleSwitchBar';
import { Alert } from '../Alert';
import { useAuth } from '../../contexts';
import {
  type SystemNotification,
  useGetSystemNotification,
} from '../../pages/UserInfo/graphql';

export const SystemNote: React.FunctionComponent = () => {
  const { role: currentRole } = useAuth();
  const location = useLocation();

  // enum of userRole (from backend) is: UserRole in src/components/RoleSwitchBar/roles.ts
  // enum of currentRole (in frontend) is: ROLES_MODULE in src/components/RoleSwitchBar/roles.ts
  // should do mapping here,  convert UserRole to ROLES_MODULE
  const convertedCurrentRole = getUserRoleByRoleModule(
    currentRole as ROLES_MODULE,
  );

  const userHomePage = roleModulesMap[currentRole as ROLES_MODULE]?.navLink;
  const isHomepage = userHomePage === location.pathname;

  const { systemNotifications, loading, error } =
    useGetSystemNotification(!isHomepage);

  if (!isHomepage) return <></>;

  function isNotificationEffective(notification: SystemNotification): boolean {
    const today = new Date();
    const { effectiveFrom, effectiveTo } = notification;
    const isAfterStartDate = today >= new Date(effectiveFrom);
    const isBeforeEndDate = effectiveTo ? today <= new Date(effectiveTo) : true;

    return isAfterStartDate && isBeforeEndDate;
  }

  function isForCurrentRole(userRoles: UserRole[]): boolean {
    return userRoles.includes((convertedCurrentRole as UserRole) ?? '');
  }

  const notificationsToShow: Array<{
    title: string;
    message: string;
    isHTML: boolean;
  }> = systemNotifications
    ?.filter(
      (note: SystemNotification) =>
        isNotificationEffective(note) &&
        isForCurrentRole(note?.userRoles ?? []),
    )
    ?.map(note => ({
      title: note.title,
      message: note.message,
      isHTML: note.isHTML,
    }));

  if (error) {
    return (
      <Alert
        openAlert={true}
        setOpenAlert={() => {}}
        alertDetails={{
          alertContent: `Error Occurs.` + (error as Error)?.message,
          alertType: 'error',
        }}
      />
    );
  }

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <Box sx={{ width: '100%' }}>
          {notificationsToShow?.map((note, index) => (
            <SystemNoteItem key={index} {...note} />
          ))}
        </Box>
      )}
    </>
  );
};
